module.exports = __webpack_public_path__ + "assets/fielseg-alt.760524a1.svg";